<template>
    <div class="crumbs-container">
        <ul class="nav-box">
            <li class="go-back" @click="goBack()">
                <div class="zuojiantou1"></div>
                <div class="zuojiantou2"></div>
                <span>返回</span>
            </li>
            <li class="go-home">
                <i class="icon iconfont icon-dangqianweizhi-icon"></i>
                <span @click="goHome()">首页</span>
            </li>
            <li class="nav-item" v-for="(item, i) in navList" :key="i" 
                :class="i===navList.length-1?'nav-active':''">
                <i class="icon iconfont icon-shuangyoujiantou"></i>
                <span @click="toItemPage(i)">{{item.name}}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'CrumbsComponent',
    data() {
        return {}
    },
    computed: {
        navList() {
            return this.$store.state.navList;
        }
    },
    created() {
        this.initNav();
        this.Bus.$on('goback', res => {
            if(res) {
                this.goBack();
            }
        });
    },
    methods: {
        initNav() {
            let data = window.sessionStorage.getItem('navList');
            if(data) {
                let _data = JSON.parse(data);
                if(_data.length > 0) {
                    let item = {
                        data: _data,
                        flag: false
                    }
                    this.$store.commit('setNavData', item);
                } else {
                    this.$store.commit('setNavData', {data: null});
                }
            }
        },
        goHome() {
            this.$store.commit('setNavData', {data: null});
            this.$router.push({name: 'Home'});
            this.Bus.$emit('clearMenuActive', true);
        },
        goBack() {
            if(this.navList.length > 0) {
                window.history.go(-1);
                this.$store.commit('deleteNavItem', true);
                if(this.navList.length === 0) {
                    this.Bus.$emit('clearMenuActive', true);
                }
            }
        },
        toItemPage(i) {
            if(i != this.navList.length - 1) {
                this.$router.push({
                    path: this.navList[i].path,
                    query: this.navList[i].query
                });
                this.$store.commit('removeNavItem', {index: i});
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './CrumbsComponent.scss';
</style>


// WEBPACK FOOTER //
// src/components/common/crumbs/CrumbsComponent.vue